import ajax from '../utils/ajax'

export default {
    loadLandmark: (name, nearSimilar) => ajax.get("/api/plots/brokerWechat/load", {params: {name, nearSimilar}}),
    loadPosition: id => ajax.get("/api/brokerWechat/position", {params: {id}}),
    loadQywxPosition: id => ajax.get("/api/qywx/position", {params: {id}}),
    addPlot: plot => ajax.post("/api/plots/brokerWechat/add", plot),
};
